import { createSlice } from '@reduxjs/toolkit';

export enum EFeatures {
  NEW_UI = 'newUi',
  GOOGLE_INTEGRATION = 'googleIntegration',
  SHOW_LANDSCAPE_THEME = 'showLandscapeTheme',
  MAGIC_IMPORT = 'magicImport',
}

export type Features = {
  [key in EFeatures]: boolean;
};

type State = {
  features: Features;
};

const initialState: State = {
  features: {
    [EFeatures.NEW_UI]: false,
    [EFeatures.GOOGLE_INTEGRATION]: false,
    [EFeatures.SHOW_LANDSCAPE_THEME]: false,
    [EFeatures.MAGIC_IMPORT]: false,
  },
};

const slice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    setFeatures: (state, action) => {
      state.features = action.payload;
    },
  },
});

export const { setFeatures } = slice.actions;

export default slice.reducer;
